import styled from 'styled-components';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  z-index= 3000;
`;

const TooltipText = styled.div`
  visibility: hidden;
  width: 220px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -110px;
  opacity: 0;
  transition: opacity 0.3s;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }

  ${TooltipContainer}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;


const InfoIcon = styled.div`
  display: inline-block;
  width: 20px;
  text-align: center;
  border-radius: 50%;
  background-color: #ccc;
  color: #333;
  line-height: 20px;
  cursor: pointer;

  &:hover ${TooltipText} {
    visibility: visible;
    opacity: 1;
  }
`;

const Tooltip = ({ children, text }) => (
  <TooltipContainer>
    {children}
    <InfoIcon>
      ?<TooltipText>{text}</TooltipText>
    </InfoIcon>
  </TooltipContainer>
);
export default Tooltip;
